import React from 'react';
import { Link } from 'react-router-dom';
import './Welcome.scss';

const IOS_TESTFLIGHT_URL = process.env.REACT_APP_TESTFLIGHT_IOS_URL || '';
const MAC_TESTFLIGHT_URL = process.env.REACT_APP_TESTFLIGHT_MAC_URL || '';

const Welcome = () => {
  return (
    <div className="welcome-page">
      <div className="welcome-card">
        <div className="welcome-check">✓</div>

        <h1>You're in.</h1>
        <p className="welcome-sub">Your Spinnin' Beans subscription is active.</p>

        <ol className="welcome-steps">
          <li>
            <span className="step-label">Get the iOS app</span>
            {IOS_TESTFLIGHT_URL ? (
              <a
                href={IOS_TESTFLIGHT_URL}
                className="step-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download on TestFlight →
              </a>
            ) : (
              <span className="step-link muted">TestFlight link coming soon</span>
            )}
          </li>

          <li>
            <span className="step-label">Get the Mac app</span>
            {MAC_TESTFLIGHT_URL ? (
              <a
                href={MAC_TESTFLIGHT_URL}
                className="step-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download on TestFlight →
              </a>
            ) : (
              <span className="step-link muted">TestFlight link coming soon</span>
            )}
          </li>

          <li>
            <span className="step-label">Sign in with the same email you used here</span>
            <span className="step-note">
              If you used Apple Sign In's "Hide My Email" at checkout, sign in
              with that same hidden email address — the apps recognize you by
              the email used during checkout, not your personal Apple ID.
            </span>
          </li>
        </ol>

        <p className="welcome-footer-note">
          Questions? Email{' '}
          <a href="mailto:josh@spinninbeans.com">josh@spinninbeans.com</a>
        </p>

        <Link to="/discover" className="welcome-discover-link">
          Explore Discover while you wait →
        </Link>
      </div>
    </div>
  );
};

export default Welcome;
